import { render, staticRenderFns } from "./AlbumItem--Card.vue?vue&type=template&id=d7a8485e&lang=pug&"
import script from "./AlbumItem--Card.vue?vue&type=script&lang=js&"
export * from "./AlbumItem--Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports